export enum Hosts {
  Duda = Boo.Objects.Websites.Enums.Hosts.Duda,
  WpEngine = Boo.Objects.Websites.Enums.Hosts.WpEngine
}